<template>
    <v-app style="width: 100%;">
        <router-view v-if="isAuthorized"></router-view>
        <div class="dl-required-form" v-if="display_required_form">
            <img :src="styles.customerLogo" alt="logo" class="bot-icon"/>
            <div style="margin-bottom: 15px;padding: 0 24px;text-align: center" :style="{
                color: styles.customerWelcomeTextColor
            }">
                <div :style="{
                    fontSize: styles.customerWelcomeTextSize,
                    fontWeight: isShowLayoutCustomer ? 'bold' : ''
                }">
                    {{ styles.customerWelcomeText }}
                </div>
                <div v-if="styles.customerWelcomeDes" class="customer-welcome-des">
                    <span v-if="styles.customerWelcomeDes" :style="{
                        fontSize:styles.customerWelcomeDesSize
                    }" v-html="styles.customerWelcomeDes"></span>
                    <a v-if="styles.customerWelcomeLinkText && styles.customerWelcomeLink" :style="{
                        fontSize:styles.customerWelcomeDesSize,
                        color: styles.customerWelcomeTextColor
                    }" :href="styles.customerWelcomeLink" class="item-link--customer" target="_blank">
                        {{styles.customerWelcomeLinkText}}
                    </a>
                </div>
            </div>
            <template v-if="styles.prefixEnable && !isShowLayoutCustomer">
                <div v-if="styles.prefixType === 'radio'">
                    <v-radio-group row class="ma-0 pa-0" v-model="prefix">
                        <v-radio
                            v-for="(option, i) in styles.prefixOptions"
                            :key="i"
                            :label="option"
                            :value="option"
                        ></v-radio>
                    </v-radio-group>
                </div>
                <div v-else>
                    <input type="text" class="input-name" :placeholder="styles.prefixPlaceholder" v-model="prefix"  maxlength="24">
                </div>
            </template>
            <input
                    v-show="!isShowLayoutCustomer"
                    ref="txt_required_name"
                    class="input-name"
                    :placeholder="styles.customerWelcomePlaceholder"
                    v-model="username"
                    @keypress.enter="enter_users_name"
                    autocomplete="off"
                    maxlength="255"
            />
            <div class="extra-information" v-if="(extra_infomarion && extra_infomarion.length > 0)">
              <div  :key="index" v-for="(info, index) in extra_infomarion">


                <select v-if="(info.type==='dropdown')"
                    :ref="'txt_' + info.variable"
                    class="input-extra-info"
                    :placeholder="info.label"
                    :required="info.required"
                    v-model="info.value"
                    :hidden="info.hidden"
                    :disabled="info.disabled"
                >
                  <option v-for="option in info.options" :value="option.value" :disabled="option.disabled">
                    {{ option.text }}
                  </option>
                </select>

                <input
                    v-else
                    :ref="'txt_' + info.variable"
                    class="input-extra-info"
                    :type="info.type"
                    :placeholder="info.label"
                    v-model="info.value"
                    autocomplete="off"
                    maxlength="100"
                    :required="info.required"
                    :pattern="info.pattern"
                    :title="info.title"
                    :hidden="info.hidden"
                    :disabled="info.disabled"
                    @blur="validate_data(info)"
                />
              </div>

            </div>
            <div v-if="styles.customerConfirmCheckbox" class="customer-confirm-box" :style="{
                color: styles.customerWelcomeTextColor
            }">
              <label for="input-confirm":style="{fontSize:styles.customerWelcomeDesSize }">
                <input type="checkbox" id="input-confirm" v-model="isConfirmed" style="margin-right: 4px;">
                {{ styles.customerConfirmCheckbox }}
              </label>
            </div>
            <div :class="isShowLayoutCustomer ? 'button-customer' : ''">
                <button
                    class="btn-start"
                    :style="{
                      background: styles.primaryColor,
                      color: styles.primaryTextColor,
                      opacity: (!styles.customerConfirmCheckbox || isConfirmed) ? 1 : 0.4
                    }"
                    @click="enter_users_name"
                    type="button"
                >
                    {{ styles.customerButtonText }}
                </button>
            </div>
            <div class="item-fpt">
              <span v-if="styles.disabledPoweredByLink === true">Powered by FPT.AI</span>
              <a v-else href="https://fpt.ai/chatbot" target="_blank">Powered by FPT.AI</a>
              <span> / </span>
              <a :href="styles.customerTermLink ? styles.customerTermLink : 'https://fpt.ai/terms-conditions'"
                target="_blank">
                Term & Conditions
              </a>
            </div>
        </div>
        <v-dialog v-model="display_reconnect_form" persistent max-width="390">
            <v-card>
                <v-card-text class="pa-1">
                    <v-btn color="primary" style="width: 100%;" text @click="reconnectSocket">Reconnect</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="display_connecting_form" persistent max-width="390">
            <v-card>
                <v-card-text class="pa-1 dl-connecting">
                    <span>CONNECTING</span>
                    <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="display_auth_error_form" persistent max-width="390" >
          <v-card>
              <v-card-text class="pa-5" style="text-align: center;">
                  <v-icon style="font-size: 60px; color: orange;">mdi-alert-outline</v-icon>
                  <p class="text-subtitle-1">Authentication failed! Please contact with administrator.</p>
              </v-card-text>
          </v-card>
        </v-dialog>

        <v-dialog id="dl_display_webview" v-model="display_webview" persistent max-width="600">
          <v-card style="width: 100%; height: 100%; overflow: hidden;">
            <v-toolbar dark color="primary" style="height:35px; background-color:#DFE0E4 !important;">
              <v-toolbar-title style="font-weight: bold !important; font-size: 16px !important;">{{ webview_header }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark small @click="display_webview = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <iframe id="ifr_display_webview" :name="ifrm_webview_name" ref="ifr_display_webview" :src="webview_url" style="width: 100%; height: calc(100% - 35px); border: 0;"></iframe>
          </v-card>
        </v-dialog>

        <a id="ctr_link" href="#" target="_blank" hidden></a>
        <a id="ctr_phone" href="#" hidden target="_blank"></a>
        <input id="ctr_upload_file" hidden type="file" name="upload_file"/>
    </v-app>
</template>

<script>
/* eslint-disable */
import $ from 'jquery'
import handlerMessage from './business/handler_messages'
import handlerData from './business/handler_data'
import { mapState } from "vuex";

import axios from 'axios'
var socketCluster = require('socketcluster-client')
var md5           = require('md5')

export default {
    name      : 'App',
    components: {},
    mounted() {
        // Custom Styles
        this.getCustomUI()

        this.fptaiEndpoint         = this.getUrlParam('scendpoint') || process.env.VUE_APP_SOCKETCLUSTER_HOST
        this.botCode               = this.getUrlParam('botcode')
        this.languageCode          = this.getUrlParam('languageCode') || ''
        this.customerTheme         = this.getUrlParam('customertheme') || ''
        if(this.getUrlParam('namecustomer') && this.getUrlParam('namecustomer') !== '') {
            this.username = this.getUrlParam('namecustomer')
        }
        this.$store.state.botCode  = this.botCode

        // check if clear session when refresh then delete cache
        let clear_session = this.getUrlParam('clear_session')
        // console.log('clear_session', clear_session)
        if (clear_session && clear_session === '1') {
          // console.log('CLEAR SESSION')
            localStorage.removeItem('fptai_livechat_client_' + this.botCode)
        }
        // console.log(localStorage.getItem('fptai_livechat_client_' + this.botCode))

        let chat_client            = {
            name : '',
            id   : '',
            token: ''
        } // UPDATE 2019/10/14 - chat_client format: name, id, token
        this.$store.state.componentsMainApp = this
        this.$store.state.bot_icon = this.getUrlParam('iconbot')
        let customize_sender_name  = this.getUrlParam('sendername')
        let subChannel = this.getUrlParam('subchannel')
        if (subChannel && subChannel !== '') {
            this.$store.state.subChannel = subChannel
        }

        //   console.log(this.getUrlParam('extra_info'))
        try{
          let extra_config = this.getUrlParam('extra_info');
          this.extra_infomarion = extra_config ? JSON.parse(extra_config) : [];
          //console.log(this.extra_infomarion);
        } catch (e) {
          // console.log(e);
        }

        // get config enable button react
        if (this.getUrlParam('react_button_enable') && this.getUrlParam('react_button_enable') == '1') {
          this.$store.state.reactButtonEnable = true;
        }

      // Update 2021-08-12 Update sender_id, sender_token from Client
      this.use_client_sender_info = false;
      if (this.getUrlParam('use_client_sender_info') && this.getUrlParam('use_client_sender_info') == '1') {
        this.use_client_sender_info = true;
        chat_client.name = customize_sender_name;
        chat_client.id = this.getUrlParam('sender_id');
        chat_client.token = this.getUrlParam('sender_token');

        // check allow send start message
        // let allow_send_start_msg = false;
        // if (localStorage.getItem('fptai_livechat_client_customer_' + this.botCode)) {
        //   let customer_client = JSON.parse(localStorage.getItem('fptai_livechat_client_customer_' + this.botCode));
        //   if (customer_client.id !== chat_client.id) {
        //     allow_send_start_msg = true;
        //   }
        // }

        // save user info to localstorage
        let data_local_client = {
          id: chat_client.id
        }
        localStorage.setItem(
            'fptai_livechat_client_customer_' + this.botCode,
            JSON.stringify(data_local_client)
        )

        this.$store.state.customSender = true;

        // get status rejectIfAuthFailed in url params
        if (this.getUrlParam('reject_if_auth_failed') && this.getUrlParam('reject_if_auth_failed') == '1') {
          this.$store.state.rejectIfAuthFailed = true;
        }

        // #DOING: set variable
        let object_payload = {
          set_attributes: {},
        };
        for (let i = 0; i < this.extra_infomarion.length; i++) {
          if (this.extra_infomarion[i].variable) {
            object_payload.set_attributes[this.extra_infomarion[i].variable] =
              this.extra_infomarion[i].value;
          }
        }
        if (this.languageCode) {
          object_payload.languageCode = this.languageCode
        }

        this.data_payload = handlerData.b64EncodeUnicode(
          JSON.stringify(object_payload)
        );
        this.$store.state.startPayload = this.data_payload;
        // #END: set variable

        this.connectSocket(chat_client);
        setTimeout(function () {
          try{
            $('#txt_input_message')[0].focus()
          } catch (e) {
            // console.log(e);
          }
        }, 500);
      }

      if (!this.use_client_sender_info) {
        // check client id in local store
        if (localStorage.getItem('fptai_livechat_client_' + this.botCode)) {
          chat_client = JSON.parse(
              localStorage.getItem('fptai_livechat_client_' + this.botCode)
          )
          this.connectSocket(chat_client, false, true)
          setTimeout(function () {
            try{
              $('#txt_input_message')[0].focus()
            } catch (e) {
              // console.log(e);
            }
          }, 500)
        } else if (customize_sender_name && customize_sender_name.trim() !== '') {

          // sender config name
          let chat_client = {
            name : customize_sender_name.trim(),
            id   : md5(handlerData.guid() + this.botCode),
            token: ''
          }
          // save users information to localstorage
          localStorage.setItem(
              'fptai_livechat_client_' + this.botCode,
              JSON.stringify(chat_client)
          )
          this.display_required_form   = false
          this.display_connecting_form = true
          this.connectSocket(chat_client, true, true)
          setTimeout(function () {
            try{
              $('#txt_input_message')[0].focus()
            } catch (e) {
              // console.log(e);
            }
          }, 500)

        } else {

          this.anomyous_sender = false;
          if (this.getUrlParam('anomyous_sender') && this.getUrlParam('anomyous_sender') == '1') {
            this.anomyous_sender = true;

            // sender config name
            let chat_client = {
              name : 'Guest ' + (new Date()).getTime(),
              id   : md5(handlerData.guid() + this.botCode),
              token: ''
            }
            // save users information to localstorage
            localStorage.setItem(
                'fptai_livechat_client_' + this.botCode,
                JSON.stringify(chat_client)
            )
            this.display_required_form   = false
            this.display_connecting_form = true
            this.connectSocket(chat_client, true, true)
            setTimeout(function () {
              try{
                $('#txt_input_message')[0].focus()
              } catch (e) {
                // console.log(e);
              }
            }, 500)
          } else {
            // request user information
            this.display_required_form   = true
            this.display_connecting_form = false
            setTimeout(
                function () {
                  this.$refs.txt_required_name.focus()
                }.bind(this),
                500
            )
          }          
        }
      }

    },

    data: () => ({
        // display form input user information
        display_required_form  : false,
        fptaiEndpoint          : '',
        botCode                : '',
        languageCode           : '',
        username               : '',
        prefix                 : '',
        customerTheme          :'',
        nameCustomer           : '',
        display_reconnect_form : false,
        display_connecting_form: true,
        display_webview: false,
        webview_header: "",
        webview_url: "",
        ifrm_webview_name: Date.now(),

        extra_infomarion: [],
        data_payload: '',
        use_client_sender_info: false,
        display_auth_error_form: false,

        anomyous_sender: false,
        
        isAuthorized: false,
        isConfirmed: false,
    }),

    methods : {
      getUrlParameter (url, parameter) {
          parameter = parameter.replace(/[\[\]]/g, "\\$&");
          var regex = new RegExp("[?&]" + parameter + "(=([^&#]*)|&|#|$)"),
              results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, " "));
      },
      async getDmWebview(botCode, data) {
        
        let api_url_msg_server = process.env.VUE_APP_API_URL_MSG_SERVER
        let url = api_url_msg_server + 'bot/'+ botCode + '/get-dm-webview/'

        let return_data = await axios.post(url, data)

        return return_data
      },
        getUrlParam(name, url) {
            if (!url) url = location.href
            name        = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            let regexS  = '[\\?&]' + name + '=([^&#]*)'
            let regex   = new RegExp(regexS)
            let results = regex.exec(url)
            return results == null ? null : decodeURIComponent(results[1])
        },

        getCustomUI() {
            let styles = this.$store.state.styles
            let customStyle = this.getUrlParam('styles')
            if (customStyle) {
                customStyle = JSON.parse(customStyle)
                for (let i in styles) {
                    if (customStyle[i]) {
                        styles[i] = customStyle[i]
                    }
                }
                if (customStyle.css) {
                    let cssCode = document.createElement('style')
                    cssCode.innerHTML = customStyle.css
                    document.head.appendChild(cssCode)
                }
            }
            // console.log(JSON.parse(JSON.stringify(customStyle)))
            this.$store.dispatch(this.$ActionTypes.SET_CUSTOM_STYLES, JSON.parse(JSON.stringify(styles)))
        },

        reconnectSocket() {
            this.$router.go(0)
        },

        connectSocket(objClient, sendStartMsg = false, allowReConnect = true) {
            // console.log('connectSocket - ' + allowReConnect)
            // console.log(objClient);
            this.$store.state.clientId    = objClient.id
            this.$store.state.clientName  = objClient.name
            this.$store.state.clientToken = objClient.token

            if (!this.$store.state.scClient) {
                // connect socket cluster
                // console.log(process.env.VUE_APP_SOCKET_SECURE);
                var sc_sercure             = process.env.VUE_APP_SOCKET_SECURE === 'secure'
                var option                 = {
                    host  : this.fptaiEndpoint,
                    secure: sc_sercure,
                    path  : '/ws/'
                }
                // console.log(option);
                this.$store.state.scClient = socketCluster.connect(option)
            }

            // send authorize request
            let data_send_request_authorize = {
                sender_id  : objClient.id,
                token      : objClient.token,
                sender_name: objClient.name,
                bot_code   : this.botCode,
                sub_channel: this.$store.state.subChannel
            }

            let _this = this

            this.$store.state.scClient.emit(
                'sender_request_authenticate',
                data_send_request_authorize,
                async function (err, data) {
                    // console.log(err);
                    // console.log(data);
                    if (err) {
                        // console.log(err);
                        // check if timeout error
                        if (err['name'] === 'TimeoutError' || err['name'] === 'BadConnectionError') {
                            // re-connect socket
                            _this.connectSocket(objClient, sendStartMsg, allowReConnect)
                        } else {
                          // authen failed
                          // get config rejectIfAuthFailed
                          let rejectIfAuthFailed = _this.$store.state.rejectIfAuthFailed
                          // if in case custom sender and rejectIfAuthFailed = true, show error form
                          if (_this.$store.state.customSender === true && rejectIfAuthFailed) {
                            _this.display_auth_error_form = true
                            _this.display_connecting_form = false
                          } else {
                            // if is customer sender, check the local storage to connect with saved sender
                            if (_this.$store.state.customSender === true && localStorage.getItem('fptai_livechat_client_' + _this.botCode)) {
                              _this.$store.state.customSender = false;
                              // try to connect with sender save in localstorage
                              let chat_client = JSON.parse(
                                  localStorage.getItem('fptai_livechat_client_' + _this.botCode)
                              )
                              _this.connectSocket(chat_client, false, true)
                              setTimeout(function () {
                                try{
                                  $('#txt_input_message')[0].focus()
                                } catch (e) {
                                  // console.log(e);
                                }
                              }, 500)
                            } else {
                              _this.$store.state.customSender = false;
                              // if allow anomyous chat
                              _this.anomyous_sender = false;
                              if (_this.getUrlParam('anomyous_sender') && _this.getUrlParam('anomyous_sender') == '1') {
                                _this.anomyous_sender = true;

                                // sender config name
                                let chat_client = {
                                  name : 'Guest ' + (new Date()).getTime(),
                                  id   : md5(handlerData.guid() + _this.botCode),
                                  token: ''
                                }
                                // save users information to localstorage
                                localStorage.setItem(
                                    'fptai_livechat_client_' + _this.botCode,
                                    JSON.stringify(chat_client)
                                )
                                _this.display_required_form   = false
                                _this.display_connecting_form = true
                                _this.connectSocket(chat_client, true, true)
                                setTimeout(function () {
                                  try{
                                    $('#txt_input_message')[0].focus()
                                  } catch (e) {
                                    // console.log(e);
                                  }
                                }, 500)
                              } else {
                                // request user information
                                _this.display_required_form   = true
                                _this.display_connecting_form = false
                                setTimeout(
                                    function () {
                                      _this.$refs.txt_required_name.focus()
                                    }.bind(_this),
                                    500
                                )
                              }
                            }
                          }
                        }
                    } else {
                        // save token to localstore
                        let chat_client = {
                            name : objClient.name,
                            id   : objClient.id,
                            token: data.sender_token
                        }

                        // save users information to localstorage
                        if (_this.use_client_sender_info && _this.$store.state.customSender) {
                          localStorage.setItem(
                              'fptai_livechat_client_customer_' + _this.botCode,
                              JSON.stringify({id: objClient.id})
                          )
                        } else {
                          localStorage.setItem(
                              'fptai_livechat_client_' + _this.botCode,
                              JSON.stringify(chat_client)
                          )
                        }
                        // save User Token to store
                        _this.$store.state.clientToken = chat_client.token

                        // ready to continue
                        _this.isAuthorized = true;

                        // create and subscribe channel
                        let scb_channel =
                                md5(objClient.id + '.' + _this.botCode) +
                                '@' +
                                _this.botCode +
                                '/livechat'

                        _this.$store.state.scClient.on('error', function (err) {
                            // console.log(err)
                            throw 'Socket error - ' + err
                        })

                        _this.$store.state.scClient.on('disconnect', function () {
                            // console.log('Socket disconnect')
                            _this.display_reconnect_form = true
                        })

                        _this.$store.state.scSubscribeChannel = _this.$store.state.scClient.subscribe(
                            scb_channel
                        )

                        _this.display_connecting_form = false

                        // _this.$nextTick(() => {
                        //     _this.$store.state.scSubscribeChannel.watch(data => {
                        //         _this.$store.state.componentsMainChatBox.handler_messages(data)
                        //     })
                        // })

                        setTimeout(function () {
                          try{
                            $('#txt_input_message')[0].focus()
                          } catch (e) {
                            // console.log(e);
                          }

                          // send message get started
                          // console.log("send_start_message - " + sendStartMsg);
                          if (sendStartMsg) {
                              // console.log("sendStartMsg - " + sendStartMsg)
                              handlerMessage.send_start_message(_this.$store.state.subChannel, _this.data_payload)
                          }
                        }, 500)
                    }
                }
            )

            let themes = this.getUrlParam('themes')
            let linkThemes
            if (themes && themes !== '') {
                switch (themes) {
                    case 'red':
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-red.css'
                        $('head').append(linkThemes)
                        break
                    case 'blue':
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-blue.css'
                        $('head').append(linkThemes)
                        break
                    default:
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-' + themes + '.css'
                        $('head').append(linkThemes)
                        break
                }
            }

            // console.log(this.$store.state.scClient);
        },

        enter_users_name() {
            if (this.styles.customerConfirmCheckbox && !this.isConfirmed) {
              return
            }
            let username = this.username.trim()
            if (username === '') {
                this.$refs.txt_required_name.focus()
                return false
            }

            if (this.styles.prefixEnable) {
                username = this.prefix.trim() + ' ' + username
            }

            let chat_client = {
                name : username,
                id   : md5(handlerData.guid() + this.botCode),
                token: ''
            }

            let object_payload = {}
            
            // handler extra data
            if (this.extra_infomarion && this.extra_infomarion.length > 0) {
              object_payload.set_attributes = {}
              let check_valid = true;
              for (let i = 0; i < this.extra_infomarion.length; i++) {
                //console.log(this.extra_infomarion[i])
                if (this.extra_infomarion[i].pattern && this.extra_infomarion[i].pattern != "" ) {
                  const regex = new RegExp(this.extra_infomarion[i].pattern);
                  if (regex.test(this.extra_infomarion[i].value)) {
                    //console.log("Passed: ", this.extra_infomarion[i].value);
                  } else {
                    //console.log("Failed: ", this.extra_infomarion[i].value);
                    let control_ref = "txt_" + this.extra_infomarion[i].variable
                    this.$refs[control_ref][0].focus()
                    check_valid = false
                    break;
                  }
                  
                }
               

                if (!this.extra_infomarion[i].value) {
                  if (this.extra_infomarion[i].required) {
                    let control_ref = "txt_" + this.extra_infomarion[i].variable
                    this.$refs[control_ref][0].focus()
                    check_valid = false
                    break;
                  }
                }

                if (this.extra_infomarion[i].variable) {
                  object_payload.set_attributes[this.extra_infomarion[i].variable] = this.extra_infomarion[i].value;
                }
              }
              
              if (!check_valid) {
                return false;
              }
            }
            if (this.languageCode) {
              object_payload.languageCode = this.languageCode
            }
            console.log(JSON.stringify(object_payload));
            this.data_payload = handlerData.b64EncodeUnicode(JSON.stringify(object_payload));

            // save users information to localstorage
            localStorage.setItem(
                'fptai_livechat_client_' + this.botCode,
                JSON.stringify(chat_client)
            )
            this.display_required_form   = false
            this.display_connecting_form = true
            this.connectSocket(chat_client, true, true)

        },
        async open_webview (title, url) {
          this.display_webview = true;
          let botCode = this.getUrlParameter(url, "bot_code");
          let senderId = this.getUrlParameter(url, "sender_id");
          let secretKey = this.getUrlParameter(url, "secret_key");
          let webviewId = this.getUrlParameter(url, "webview_id");
          let channel = this.getUrlParameter(url, "channel");
          let data = {
            sender_id: senderId,
            secret_key: secretKey,
            webview_id: webviewId
          }
          if(channel === 'livechat'){
            let webview = await this.getDmWebview(botCode, data)
            let webview_config = JSON.parse(webview.data.config)
            if(webview){
              this.webview_header = webview_config.title
            }
          }
          
          if (this.$refs.ifr_display_webview) {
            this.$refs.ifr_display_webview.contentWindow.location.replace('');
          }
          this.$nextTick(() => {
            // this.webview_url = url;
            this.$refs.ifr_display_webview.parentNode.parentNode.parentNode.id = "dl_display_webview"
            this.$refs.ifr_display_webview.contentWindow.location.replace(url);
          });
        },
        close_webview() {
          this.display_webview = false;
        },
        gotoFpt () {
            window.open('https://fpt.ai/chatbot', '_blank')
        },
        gotoFptTerm () {
          window.open(this.styles.customerTermLink ? this.styles.customerTermLink : 'https://fpt.ai/terms-conditions', '_blank')
        },
        // extra information
        validate_data(item) {
          //console.log("validate: ", item)
          if (item.type === 'number') {
            // item.value = item.value.replaceAll(' ', '').replaceAll('.', '').replaceAll('-', '');
            item.value = item.value.replaceAll(/[^1234567890]/gi, '')
          } else {
            // default text
          }
        },
    },
    computed: {
        ...mapState(['styles']),
        baseUrl() {
            return process.env.BASE_URL
        },
        isShowLayoutCustomer() {
            return this.customerTheme === 'theme1'
        }
    }
}
</script>

<style>
  @import './assets/style.css';

    .v-application--wrap {
        width : 100% !important;
    }
    #dl_display_webview header {
      background-color: #fff !important;
      color: #424242;
    }
    #dl_display_webview header i {
      color: #424242;
    }
    #dl_display_webview header > div {
      height: 35px !important;
    }
    @media screen and (min-width: 768px) {
      #dl_display_webview div.v-dialog {
        height: 90%;
        max-height: 700px;
      }
    }
    @media screen and (max-width: 767px) {
      #dl_display_webview div.v-dialog {
        height: 100%;
        max-height: 100%;
        margin: 0;
        bottom: 0;
      }
    }
    
    .customer-welcome-des a {
      text-decoration: underline;
      font-weight: bold;
      color: inherit !important;
    }
    .customer-welcome-des a:hover {
      color: inherit !important;
    }

</style>

<style scoped lang="scss">
    .dl-required-form {
        width            : 100%;
        height           : 100%;
        z-index          : 2000;
        position         : absolute;
        top              : 0;
        left             : 0;
        background-color : #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .dl-required-form .v-image {
        position : absolute;
        top      : calc(20% - 30px);
        left     : calc(50% - 34px);
    }
    .dl-required-form .input-name {
        height: 40px;
        width: 250px;
        border-radius: 40px;
        background: #f2f2f2;
        margin-bottom: 10px;
        text-align: center;

        &:focus {
            outline: solid #c3c3c3 1px;
        }
    }

    .dl-required-form .extra-information {
      position: relative;
      /* height: 50px; */
      div {
        margin-bottom: 10px;
      }

      .input-extra-info {
        width         : 250px;
        height        : 40px;
        /* position      : absolute; */
        top           : calc(60% - 70px);
        left          : calc(50% - 125px);
        text-align    : center;
        font-size     : 16px;
        outline       : none;
        margin        : 0 auto;
        background    : #f2f2f2;
        border-radius : 100px;
        padding       : 0 10px;

        &:focus {
            outline: solid #c3c3c3 1px;
        }
      }
    }

    .dl-connecting {
        text-align : center;
    }
    .dl-connecting span {
        display    : block;
        margin-top : 20px;
    }
    .dl-connecting .lds-facebook {
        display  : inline-block;
        position : relative;
        width    : 80px;
        height   : 80px;
    }
    .dl-connecting .lds-facebook div {
        display   : inline-block;
        position  : absolute;
        left      : 8px;
        width     : 16px;
        animation : lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
    .dl-connecting .lds-facebook div:nth-child(1) {
        left            : 8px;
        animation-delay : -0.24s;
        background      : #6d9ccb;
    }
    .dl-connecting .lds-facebook div:nth-child(2) {
        left            : 32px;
        animation-delay : -0.12s;
        background      : #3aa4c9;
    }
    .dl-connecting .lds-facebook div:nth-child(3) {
        left            : 56px;
        animation-delay : 0;
        background      : #00afc8;
    }
    @keyframes lds-facebook {
        0% {
            top    : 8px;
            height : 64px;
        }
        50%,
        100% {
            top    : 24px;
            height : 32px;
        }
    }
    .customer-welcome-des {
      padding-top: 12px;
    }
    .customer-confirm-box {
      margin-bottom: 15px;
      padding: 0 24px;
      text-align: center
      input {
        margin-right: 4px;
      }
    }
    .button-customer {
        display: flex;
        align-items: center;
        justify-content: end;
        width: inherit;
        padding: 0 24px;
    }
    .item-fpt {
        padding: 7px 12px;
        color: rgba(107, 110, 121, 0.8);
        font-style: italic;
        font-size: 12px;
        border-radius: 40px;
        margin-top: 10px;
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        text-align: center;
        a {
          color: rgba(107, 110, 121, 0.8);
          text-decoration: none;
          &:hover {
            color:#1976d2 ;
          }
        }
    }
    .item-link--customer{
        font-weight: bold;
    }
    .bot-icon {
        height: 50px;
        margin-bottom: 15px;
    }

    .btn-start {
        height: 40px;
        border-radius: 40px;
        background: blue;
        padding: 0 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 14px;
        min-width: 90px;
        cursor: pointer;
    }
</style>
